export enum FontVariantEnum {
  Default = "default",
  Small = "small",
  ExtraSmall = "extra-small",
}
